module.exports = __webpack_public_path__ + "img/61f4652c6533e0650b55d58d_blanco-d.83caf968.png";